import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import warning from 'warning';

var Alert = /*#__PURE__*/function (_React$Component) {
  _inherits(Alert, _React$Component);

  var _super = _createSuper(Alert);

  function Alert(props) {
    var _this;

    _classCallCheck(this, Alert);

    _this = _super.call(this, props);

    _this.onClose = function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }

      _this.close();
    };

    _this.close = function () {
      _this.setState({
        closed: true
      });
    };

    _this.renderClose = function () {
      if (_this.props.dismissable || _this.props.closable) {
        return /*#__PURE__*/React.createElement("a", {
          className: "close",
          onClick: _this.onClose
        }, /*#__PURE__*/React.createElement("i", {
          className: "roo-icon roo-icon-close"
        }));
      }

      return null;
    };

    if (props.dismissable) {
      warning(false, 'Roo Alert: `dismissable` 已废弃，请使用 `closable`');
    }

    _this.state = {
      closed: false
    };
    return _this;
  }

  _createClass(Alert, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isShow = _this$props.isShow,
          type = _this$props.type,
          title = _this$props.title,
          extra = _this$props.extra,
          showIcon = _this$props.showIcon,
          icon = _this$props.icon,
          className = _this$props.className,
          style = _this$props.style;
      var closed = this.state.closed;
      return /*#__PURE__*/React.createElement("div", null, isShow && !closed ? /*#__PURE__*/React.createElement("div", {
        className: "roo-alert roo-alert-".concat(type, " ").concat(className),
        style: style,
        role: "alert"
      }, showIcon ? /*#__PURE__*/React.createElement("i", {
        className: "roo-icon ".concat(icon)
      }) : null, /*#__PURE__*/React.createElement("span", {
        className: "roo-title"
      }, title), extra ? /*#__PURE__*/React.createElement("a", {
        className: "extra"
      }, extra) : this.renderClose()) : null);
    }
  }]);

  return Alert;
}(React.Component);

Alert.propTypes = {
  type: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.any,
  showIcon: PropTypes.bool,
  dismissable: PropTypes.bool,
  closable: PropTypes.bool,
  extra: PropTypes.any,
  isShow: PropTypes.bool,
  onClose: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object
};
Alert.defaultProps = {
  icon: 'roo-icon-check-circle',
  showIcon: true,
  dismissable: false,
  closable: false,
  extra: '',
  type: 'info',
  isShow: true,
  title: '',
  onClose: function onClose() {},
  className: '',
  style: {}
};
export default Alert;